import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function TePreviewOpen() {
  const { token } = useParams();
  const [error, setError] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    axios.get(`${API}/api/te-previews/open/${token}`)
      .then((r) => window.location.replace(`${API}${r.data.entry_url}`))
      .catch((e) => setError(e?.response?.data?.detail || "This preview link could not be opened."));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0f1b2d] text-white p-6" data-testid="te-preview-open-page">
      <div className="max-w-md text-center space-y-4">
        <div className="text-3xl font-bold tracking-tight" style={{ fontFamily: "Georgia, serif" }}>MOSAIC</div>
        {!error ? (
          <p className="text-slate-300" data-testid="te-preview-loading">Opening your Teacher Edition Preview… this can take up to a minute the first time.</p>
        ) : (
          <>
            <p className="text-lg" data-testid="te-preview-error">{error}</p>
            <p className="text-slate-300 text-sm">Need a new link? Email <a className="underline" href="mailto:orders@mosaicassessmentco.com">orders@mosaicassessmentco.com</a>.</p>
          </>
        )}
      </div>
    </div>
  );
}
